import React from 'react';
import data from '../../../data/blogs.json';

function Posts() {
  return (
    <section className="sec-box blog section-padding pt-0">
      <div className="row">
        <div className="col-12">
          <div className="sec-head bord-thin-bottom pb-20 mb-80">
            <h4 className="sub-title fz-28">All Posts</h4>
          </div>
        </div>
      </div>
      <div className="row md-marg">
        {data.map((item, index) => (
          <div key={index} className="col-lg-4">
            <div className="item md-mb30 mb-30">
              <div className="img">
                <img src={item.photo} alt="" />
              </div>
              
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Posts;
